<template>
  <div class="skt-dcb">
    <div class="ticket-coupon-wrap">
      <div class="ticket-coupon">
        <h2 class="ticket-coupon-tit" tabindex="0">코인충전</h2>
        <img src="../../assets/images/ticket/icon-coin-l.png" alt="코인"/>
        <p class="ticket-coupon-text" tabindex="0">코인을 충전하시면 단건 구매시 쉽고 빠르게<br/>구매하실 수 있습니다.</p>
        <div class="ticket-coupon-input">
          <button @click="registerCoin()">충전하기</button>
        </div>
        <div class="coupon-noti">
          <p class="dot-text">
            <span>충전하신 코인의 유효기간은 5년이며 유효기간이 지난 코인은 소멸되어<br/>사용하실 수 없습니다.</span></p>
          <p class="dot-text"><span>한 ID당 보유할 수 있는 총 코인은 20만원 이하입니다. </span></p>
          <p class="dot-text"><span>자동결제 시 보유 코인이 20만원 이상인 경우 자동으로 결제가 해지됩니다.</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { showCoinPopup } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'

  export default {
    data () {
      return {
        couponText: '',
        hasLogin: cookie.getCredential() !== 'none'
      }
    },
    methods: {
      registerCoin () {
        showCoinPopup({ returnUrl: `${location.origin}/callback.html?action=ClosePopup`, isDcb: true })
      }
    },
    created () {
      if (!this.hasLogin) {
        this.$router.replace(`/member/login?referer=${this.$route.fullPath}`)
      }
    }
  }
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
<style scoped>
  .skt-dcb .ticket-coupon-wrap{
    padding: 158px 0 50px;
  }

  .skt-dcb .ticket-coupon{
    float: none;
    width: 435px;
    margin: 0 auto;
  }

  .skt-dcb .ticket-coupon:first-child,
  .skt-dcb .ticket-coupon:last-child{
    padding: 0;
  }

  .skt-dcb .ticket-coupon:first-child button{
    float: none;
  }
</style>
